<template>
  <div class="nav-header">
    <!-- origin nav -->
    <div class="content" id="navContent">
      <div @click="originNavClick">
        <img class="l" src="@/assets/m/logo.png" alt="" />
        <div class="title1">{{ $t("navbar.index") }}</div>
      </div>
      <img class="r" @click="showNav" src="@/assets/m/menu.png" alt="" />
    </div>

    <van-popup
      v-model="shows1"
      class="mobile-nav-popup"
      :overlay-style="{ background: 'rgba(4, 13, 35, 0.15)' }"
    >
      <div class="navTag">
        <!-- popup内的nav -->
        <div class="navtitle">
          <div class="titlall">
            <div class="title1" @click="goPage('/m/Index')">
              <img class="l logo" src="@/assets/m/logo.png" />{{
                $t("navbar.index")
              }}
            </div>
            <div>
              <img
                class="r"
                @click="shows1 = false"
                src="@/assets/m/no.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <Collapse v-model="activeName" accordion>
          <!--learn-->
          <CollapseItem name="learn">
            <template #title>
              {{ type === "zh" ? "学习" : "Learning" }}</template
            >

            <div
              class="van-collapse-item-text"
              :class="{ highlight: Scolor == '1-1' }"
              @click="goPage('/m/About')"
            >
              <div>About DO Network</div>
            </div>

            <div
              class="van-collapse-item-text"
              :class="{ highlight: Scolor == '1-2' }"
              @click="goPage('/m/Token')"
            >
              <div>DO Token&Economy</div>
            </div>
            <div
              class="van-collapse-item-text"
              :class="{ highlight: Scolor === '1-3' }"
             
            >
            <a target="_blank" href="https://fastcdn.donetwork.io/media/DONetwork+whitepaper.pdf">
              <div>White Paper</div>
            </a>
            </div>

            <div
              class="van-collapse-item-text"
              :class="{ highlight: Scolor == '1-4' }"
              @click="goPage('/m/User')"
            >
              <div>User Guide</div>
            </div>
            <a href="https://www.donetwork.io/doc/" target="_blank">
              <div
                class="van-collapse-item-text"
                :class="{ highlight: Scolor == '1-5' }"
               
              >
                <div>DO Wiki</div>
              </div>
            </a>
            <!-- <a
              href="https://docs.google.com/spreadsheets/d/19uK1oakro0ZGnJnOowRqLHG-jLAderInuZDKvwzn21k/edit?gid=0#gid=0"
              target="_blank"
            >
              <div class="van-collapse-item-text">
                <div>Ecology Profolio</div>
              </div>
            </a> -->
            <!-- <a href="https://explorer.donetwork.io/" target="_blank"> -->
            <div
              class="van-collapse-item-text"
              :class="{ highlight: Scolor == '1-6' }"
              @click="goPage('/m/TechRoadmap')"
            >
              <div>Roadmap</div>
            </div>
            <!-- </a> -->

            <div
              class="van-collapse-item-text"
              :class="{ highlight: Scolor == '1-7' }"
              @click="goPage('/m/Brand')"
            >
              <div>Brand Kits</div>
            </div>
            <!-- app下载开始 -->
            <!-- <a href="https://apps.apple.com/us/app/sunnywallet/id6633413398">
              <div class="van-collapse-item-text">
                <div @mouseover="mouseover()" @mouseout="mouseout()">
                  <img :src="img" />iOS Wallet
                </div>
              </div>
            </a>
           
            <a href="https://fastcdn.donetwork.io/apk/Sunny-Wallet.apk">
              <div class="van-collapse-item-text">
                <div @mouseover="mouseovera()" @mouseout="mouseouta()">
                  <img :src="imga" />Android Wallet
                </div>
              </div>
            </a> -->
          </CollapseItem>
          <!--  Technology-->
          <CollapseItem name="Developer ">
            <template #title>
              {{ type === "zh" ? "技术" : "Developer" }}</template
            >

            <div
              class="van-collapse-item-text"
              :class="{ highlight: Scolor == '2-5' }"
            >
              <div>
                <a
                  target="_blank"
                  href="https://www.donetwork.io/doc/developer/"
                >
                  Developer Documentation
                </a>
              </div>
            </div>

            <div
              class="van-collapse-item-text"
              :class="{ highlight: Scolor === '2-1' }"
            >
              <a target="_blank" href="https://www.donetwork.io/doc/">
                <div>Deploy Documentation</div>
              </a>
            </div>

            <div
              class="van-collapse-item-text"
              :class="{ highlight: Scolor == '2-2' }"
            >
              <a target="_blank" href="https://www.donetwork.io/doc/json-rpc/">
                <div>API Documentation</div>
              </a>
            </div>

            <div
              class="van-collapse-item-text"
              :class="{ highlight: Scolor == '2-3' }"
            >
              <div @click="goPage('/m/GrantApplication')">
                <!-- <a
                  target="_blank"
                  href="http://47.98.110.210/doc/learn/stake-trustor/stake"
                > -->
                Submit Your Application

                <!-- </a> -->
              </div>
            </div>
            <!-- <div
              class="van-collapse-item-text"
              :class="{ highlight: currentPath == '/m/NetDao' }"
              @click="goPage('/m/NetDao')"
            >
              <div>DO organization</div>
            </div> -->
            <div
              class="van-collapse-item-text"
              :class="{ highlight: Scolor == '2-4' }"
            >
              <a href="https://www.donetwork.io/doc/" target="_blank">
                <div>RUN A NODE</div>
              </a>
            </div>
          </CollapseItem>
          <!--  Developers-->
          <CollapseItem name="Community">
            <template #title>
              {{ type === "zh" ? "开发者" : "Community" }}
            </template>
            <div class="van-collapse-item-text">
              <div @click="buildPage">Governance</div>
            </div>
          </CollapseItem>

          <!-- Community -->
          <CollapseItem name="Explore DO network">
            <template #title>
              {{ type === "zh" ? "社区" : "Explore DO network" }}
            </template>
            <!-- app下载开始 -->
            <a href="https://apps.apple.com/hk/app/sunnywallet/id6633413398">
              <div class="van-collapse-item-text">
                <div @mouseover="mouseover()" @mouseout="mouseout()">
                  <img :src="img" />iOS Wallet
                </div>
              </div>
            </a>

            <a href="javascript:void(0)" @click.stop.prevent="toggleAndroidWallet">
              <div class="van-collapse-item-text">
                <div @mouseover="mouseovera()" @mouseout="mouseouta()">
                  <img :src="imga" />Android Wallet
                </div>
              </div>
            </a>
            <a href="https://explorer.donetwork.io/" target="_blank">
              <img
                src="../../assets/m/1.png"
                style="
                  margin-top: 50px;
                  width: 325px;
                  height: 40px;
                  margin: 0 auto;
                "
                />
            </a>
          </CollapseItem>
        </Collapse>
        <div class="bottom">
          <div class="bot">
            <!-- <div class="dialog">
              <img src="../../assets/icon/ava.png" />
            </div>
            <div class="button">Binding the wallet</div> -->
            <div class="community">
              <a target="_blank" href="https://x.com/Donetwork_club">
                <img src="../../assets/m/2.png" />
              </a>
              <a target="_blank" href="https://discord.gg/donetwork">
                <!-- <a target="_blank"> -->
                <img src="../../assets/m/3.png" />
              </a>
              <a target="_blank" href="https://t.me/DoNetworkclub">
                <img src="../../assets/m/4.png" />
              </a>
              <a target="_blank" href="https://github.com/DONetworkChain">
                <img src="../../assets/m/5.png" />
              </a>
              <a target="_blank" href="https://donetwork.medium.com/">
                <img src="../../assets/m/6.png" />
              </a>
              <a target="_blank" href="https://galxe.com/DONetwork ">
                <img src="../../assets/m/7.png" />
              </a>
              <a
                target="_blank"
                href="https://zealy.io/cw/donetwork/questboard"
              >
                <img src="../../assets/m/8.png" />
              </a>
              <!-- <a
                target="_blank"
                href="https://www.youtube.com/channel/UCejTsF2te-_SstSj29sLVhA"
              >
                <img src="../../assets/icon/youtube_@2x.png" />
              </a> -->
              <!-- <a target="_blank" href="https://donetwork.medium.com/">
                <img src="../../assets/icon/medium_@2x.png" />
              </a> -->
              <!--              <a target="_blank" >-->
              <!--                <img src="../../assets/icon/discord@2x.png" />-->
              <!--              </a>-->
              <!--              <a target="_blank" href="https://github.com/DONetworkChain/DONetwork">-->
              <!--                <img src="../../assets/icon/github@2x.png" />-->
              <!--              </a>-->
              <!--              <a target="_blank" >-->
              <!--                <img src="../../assets/icon/youtube@2x.png" />-->
              <!--              </a>-->
            </div>
            <div class="bottom-copyright">{{ $t("navbar.copy") }}</div>
            <div class="bottom-copyright">{{ $t("navbar.message") }}</div>
          </div>
        </div>
      </div>
    </van-popup>
    <div
      v-if="showAndroidWallet"
      class="android-wallet-mask"
      @click.self="closeAndroidWallet"
    >
      <div class="android-wallet-panel">
        <img
          class="android-wallet-qr"
          :src="androidDownloadQrcode"
          alt="Android download qr"
        />
        <a
          class="android-wallet-btn"
          href="https://fastcdn.donetwork.io/apk/Sunny-Wallet.apk"
          target="_blank"
          rel="noopener noreferrer"
        >
          Android Download
        </a>
        <div class="android-wallet-tip">Scan the QR code or download directly</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Collapse, CollapseItem } from "vant";

export default {
  components: {
    // Login,
    // CheckUser,
    Collapse,
    CollapseItem,
    // ShowMoney,
  },
  watch: {
    deep: true,
    $route: {
      handler: function (route) {
        // console.log(route);
        if (route.path == "/m/About") {
          this.Scolor = "1-1";
        } else if (route.path == "/m/Token") {
          this.Scolor = "1-2";
        } else if (route.path == "/m/User") {
          this.Scolor = "1-3";
        } else if (route.path == "/m/TechRoadmap") {
          this.Scolor = "1-5";
        } else if (route.path == "/m/Brand") {
          this.Scolor = "1-6";
        } else if (route.path == "/m/GrantApplication") {
          this.Scolor = "2-3";
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      shows1: false, // popup显示隐藏
      shows2: false,
      moneyAddress: "",
      activeName: "",
      // navList: navList,
      headerclass: true,
      show: false,
      type: "",
      userName: "",
      isLogin: true,
      dialogType: "",
      dialogVisible: false,
      userMenu: false,
      usersStatus: "",
      Scolor: "",
      currentPath: "/m/Intro", //当前路由地址
      img: require("../../assets/m/apple.png"),
      img2: require("../../assets/m/apple.png"),
      img1: require("../../assets/m/applea.png"),
      imga: require("../../assets/m/androida.png"),
      imga1: require("../../assets/m/android.png"),
      imga2: require("../../assets/m/androida.png"),
      androidDownloadQrcode: require("../../assets/m/download.png"),
      showAndroidWallet: false,
    };
  },
  mounted() {
    // window.addEventListener("scroll", this.handleScroll, true);
    this.type = this.$i18n.locale;
    this.userName = localStorage.getItem("username");
    if (this.userName) {
      this.isLogin = false;
    }
    // 监听（绑定）滚轮 滚动事件
  },
  created() {
    this.userName = localStorage.getItem("username");
    if (this.userName) {
      this.isLogin = false;
    }
    let _path = sessionStorage.getItem("currentPath");
    if (_path) {
      this.currentPath = "";
    }
    // this.checkUsersStatus();
  },

  methods: {
    toggleAndroidWallet() {
      this.showAndroidWallet = !this.showAndroidWallet;
    },
    closeAndroidWallet() {
      this.showAndroidWallet = false;
    },
    mouseover() {
      this.img = this.img1;
    },
    mouseout() {
      this.img = this.img2;
    },
    mouseovera() {
      this.imga = this.imga1;
    },
    mouseouta() {
      this.imga = this.imga2;
    },
    originNavClick() {
      this.$router.push("/");
      if (sessionStorage.getItem("currentPath")) {
        sessionStorage.removeItem("currentPath");
      }
      this.currentPath = "";
    },
    goPage(url) {
      this.$router.push(url);
      this.show = false;
      this.shows1 = false;
      this.showAndroidWallet = false;
      this.currentPath = url;
      sessionStorage.setItem("currentPath", url);
    },
    buildPage() {
      /* const h = this.$createElement;
        this.$message({
          message: h('p', null, [
            h('span', null, 'In Building '),
            h('i', { style: 'color: teal' }, '...'),
          ]),
          type: 'warning',
        }); */
      this.$message({
        message: "In Building...",
        type: "warning",
      });
    },
    showUserMenu(item) {
      this.userMenu = true;
      this.show = false;
      this.showsubmenu = true;
    },
    showUserInfo(name) {
      this.isLogin = false;
      this.userName = name;
    },
    check() {
      this.dialogVisible = true;
      this.dialogType = "check";
      this.shows2 = true;
      this.shows1 = false;
    },
    close() {
      this.dialogVisible = false;
      this.dialogType = "";
      this.shows1 = false;
      this.shows2 = false;
      //  var mo=function(e){e.preventDefault();};
      //   document.body.style.overflow='';//出现滚动条
      //   document.removeEventListener("touchmove",mo,false);
    },
    handleClose(done) {
      this.$confirm(
        this.$t("index.switch") === "cn" ? "确认关闭？" : "Confirm shutdown?"
      )
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    changelang() {
      let type = "";
      if (this.type === "en") {
        type = "zh";
        this.language = "EN";
      }
      if (this.type === "zh") {
        type = "en";
        this.language = "中文";
      }
      this.show = false;
      sessionStorage.setItem("locale", type);
      this.type = sessionStorage.getItem("locale");
      this.$i18n.locale = sessionStorage.getItem("locale");
      // this.show = false;
    },

    showNav() {
      // const { show } = this;
      // this.show = !show;
      this.showAndroidWallet = false;
      this.shows1 = true;
    },
    // back() {
    //   // if(!this.show) return
    //   this.userMenu = false;
    //   this.show = false;
    //   this.showsubmenu = false;
    // },
  },
};
</script>

<style lang="less">
@font-face {
  font-family: "PingFang SC";
  src: url("../../assets/iconfont/PingFang-SC-Medium.ttf");
  font-weight: normal;
  font-style: normal;
}
.nav-header {
  width: 100vw;
  height: 110px;
  z-index: 99999;
  // border: 1px solid green;
  .content {
    padding-right: 42px;
    height: 110px;
    display: flex;
    background: #fff;
    justify-content: space-between;
    align-items: center;
    .title1 {
      font-size: 30px;
      font-family: Poppins-Black, Poppins;
      font-weight: 800;
      color: #4573e7;
      line-height: 39px;
    }
    .subTitle {
      font-family: Poppins-Medium, Poppins;
    }
    div {
      display: flex;
      align-items: center;
    }
    .l {
      width: 39px;
      height: 39px;
      opacity: 1;
      margin-right: 17px;
      margin-left: 50px;
    }
    .r {
      width: 39px;
      height: 39px;
    }
    .l2 {
      width: 84px;
      height: 62px;
      margin-left: 15px;
    }
  }
  .navTag {
    width: 100vw;
    min-height: 100vh;
    min-height: 100dvh;
    z-index: 9999999;
    -webkit-box-orient: vertical;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    display: flex;
    flex-direction: column;
    background: #fff;
    padding-bottom: env(safe-area-inset-bottom);
    .navtitle {
      position: sticky;
      top: 0;
      z-index: 2;
      width: 100%;
      height: 110px;
      background: #fff;
      .titlall {
        display: flex;
        align-content: space-between;
        justify-content: space-between;
      }
      .r {
        width: 39px;
        height: 39px;
      }

      // transform: translateZ(0);
      // -webkit-transform: translateZ(0);
      // top: 0;
      // justify-content: space-between;
      // align-items: center;
      div {
        display: flex;
        align-items: center;
      }
      .l {
        width: 39px;
        height: 39px;
        opacity: 1;
        margin-right: 17px;
        margin-left: 50px;
      }
      .title1 {
        font-family: Poppins-ExtraBold, Poppins;
        font-size: 30px;
        font-weight: 800;
        color: #4573e7;
        line-height: 110px;
        text-align: left;
      }
      .r {
        width: 47px;
        height: 47px;
        margin-right: 40px;
      }
    }
    van-cell {
      height: 120px;
      background: #ffffff;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
    }
    a {
      font-size: 28px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(21, 27, 38, 0.5);
      line-height: 33px;
    }
    .van-cell__title {
      height: 120px;
      font-size: 30px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 120px;
      padding-left: 50px;
    }
    i.van-icon {
      padding-right: 50px;
      padding-top: 39px;
      color: #333333;
      width: 12px;
      height: 12px;
      opacity: 1;
    }
    .van-collapse-item__content {
      margin-left: 30px;
      margin-right: 30px;
    }
    .van-collapse-item-text {
      font-size: 28px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(21, 27, 38, 0.5);
      line-height: 33px;
      padding-top: 20px;
      padding-bottom: 20px;

      div {
        padding-top: 20px;
        padding-left: 20px;
        a {
          display: block;
          // color: #0046ff;
        }
        a:hover {
          color: #0046ff;
        }
        img {
          width: 40px;
          height: 40px;
          margin-top: -5px;
          margin-right: 10px;
        }
      }
      .ahightlight {
        color: #0046ff;
      }
    }
    .highlight {
      color: #0046ff;
      background: rgba(0, 0, 0, 0.04);
      opacity: 1;
      font-size: 28px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      border-radius: 10px;
    }
  }
  .android-wallet-mask {
    position: fixed;
    inset: 0;
    z-index: 2600;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.45);
    padding: 24px 16px;
    box-sizing: border-box;
  }
  .android-wallet-panel {
    width: 220px;
    max-width: calc(100vw - 32px);
    padding: 16px 14px 14px;
    border-radius: 16px;
    background: #0f1830;
    box-shadow: 0 18px 42px rgba(0, 0, 0, 0.32);
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .android-wallet-qr {
    width: 160px;
    height: 160px;
    border-radius: 14px;
    background: #fff;
    object-fit: cover;
  }
  .android-wallet-btn {
    margin-top: 12px;
    width: 100%;
    height: 46px;
    border-radius: 12px;
    background: linear-gradient(180deg, #4e8cff 0%, #1f5cff 100%);
    color: #fff;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    white-space: nowrap;
    line-height: 1;
  }
  .android-wallet-tip {
    margin-top: 8px;
    color: rgba(255, 255, 255, 0.72);
    font-size: 14px;
    line-height: 1.5;
    text-align: center;
  }
  .bottom {
    flex: 1;
    width: 100%;
    background: #fafafa;
    border-radius: 0px 0px 0px 0px;
    margin-top: auto;
  }
  .bot {
    width: calc(100vw - 100px);
    min-height: 660px;
    left: 0;
    position: relative;
    top: 20px;
    margin: 0 auto;
    text-align: center;
    .dialog {
      margin: 0 auto;
      margin-bottom: 60px;
      img {
        width: 100px;
        height: 100px;
        opacity: 1;
      }
    }
    .button {
      margin-bottom: 60px;
      height: 80px;
      background: #4573e7;
      opacity: 1;
      text-align: center;
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 80px;
    }
    .community {
      margin-top: 40px;
      margin-bottom: 40px;
      img {
        margin-right: 40px;
        width: 40px;
        height: 40px;
        background: rgba(255, 255, 255, 0.01);
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
      }
    }
    .bottom-copyright {
      margin: 0 20px 10px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.5);
      line-height: 30px;
    }
  }
}

.mobile-nav-popup {
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: transparent;
}
</style>
